import React from 'react'
import { createRoot } from 'react-dom/client'
import DisclosureModal from './disclosureModal.jsx'

class DisclosureModalElement extends HTMLElement {
  connectedCallback() {
    const reactContainerId = 'disclosure-modal-react-app'
    const reactContainer = document.createElement('div')
    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(<DisclosureModal />)
  }
}

customElements.define('disclosure-modal', DisclosureModalElement)
